
import Instance from './resource'
import qs from "qs"
export default {
  // 登录
  postLogin(data) {
    return Instance.post('/Home/Login', qs.stringify(data));
  },
  // 获取玩家昵称
  getNickName(data) {
    return Instance.post('/Account/GetAccount', qs.stringify(data));
  },
  // 注销
  postLoginOut(data) {
    return Instance.post('/Home/LoginOut', qs.stringify(data));
  },
  // 发送短信验证码
  getSendMsgCode(data) {
    return Instance.post('/MsgHandle/SendMsgCode', qs.stringify(data));
  },
  // 上传图片
  postUpLoadImg(data) {
    return Instance.post('/Upload/upLoadImg', qs.stringify(data));
  },
  // 给服务器的接口-预警
  getQunFangKaEarlyWarning(data) {
    return Instance.post('/ServerApi/QunFangKaEarlyWarning', qs.stringify(data));
  },
  // 给服务器的接口-转入房卡
  postRollIn(data) {
    return Instance.post('/ServerApi/RollIn', qs.stringify(data));
  },
  // 给服务器的接口-转出房卡
  postRollOut(data) {
    return Instance.post('/ServerApi/RollOut', qs.stringify(data));
  },
  // 获取群比例
  getQunBiLi(data) {
    return Instance.post('/AQun/QunReward/GetQunBiLi', qs.stringify(data));
  },
  // 设置群比例
  setQunBiLi(data) {
    return Instance.post('/AQun/QunReward/SetQunBiLi', qs.stringify(data));
  },
  // 获取仓库群房卡
  getBankFangKa(data) {
    return Instance.post('/AQun/QunFangKa/GetBankFangKa', qs.stringify(data));
  },
  // 获取群的群房卡
  getQunFangKa(data) {
    return Instance.post('/AQun/QunFangKa/GetQunFangKa', qs.stringify(data));
  },
  // 转入房卡
  getRollIn(data) {
    return Instance.post('/AQun/QunFangKa/RollIn', qs.stringify(data));
  },
  // 获取群信息
  getQun(data) {
    return Instance.post('/AQun/QunManager/GetQun', qs.stringify(data));
  },
  // 添加群
  addQun(data) {
    return Instance.post('/AQun/QunManager/Add', qs.stringify(data));
  },
  // 删除群
  deleteQun(data) {
    return Instance.post('/AQun/QunManager/Delete', qs.stringify(data));
  },
  // 设置副群主
  setFuQunZhu(data) {
    return Instance.post('/AQun/QunManager/SetFuQunZhu', qs.stringify(data));
  },
  // 移除副群主
  removeFuQunZhu(data) {
    return Instance.post('/AQun/QunManager/RemoveFuQunZhu', qs.stringify(data));
  },
  // 群打烊-开启
  starShutdown(data) {
    return Instance.post('/AQun/QunManager/Shutdown', qs.stringify(data));
  },
  // 群打烊-关闭
  endShutdown(data) {
    return Instance.post('/AQun/QunManager/EndShutdown', qs.stringify(data));
  },
  // 自动转入
  qunFangKaAutoRollIn(data) {
    return Instance.post('/AQun/QunManager/QunFangKaAutoRollIn', qs.stringify(data));
  },
  // 群房卡提醒
  qunFangKaTip(data) {
    return Instance.post('/AQun/QunManager/QunFangKaTip', qs.stringify(data));
  },
  // 添加群成员 
  addMember(data) {
    return Instance.post('/AQun/QunMemberManager/AddMember', qs.stringify(data));
  },
  // 移除群成员
  removeMember(data) {
    return Instance.post('/AQun/QunMemberManager/RemoveMember', qs.stringify(data));
  },
  // 群意见审批
  auditSome(data) {
    return Instance.post('/AQun/QunMemberManager/Audit', qs.stringify(data));
  },
  // 获取群成员信息
  getQunMember(data) {
    return Instance.post('/AQun/QunMemberManager/GetQunMember', qs.stringify(data));
  },
  // 群主修改邀请人
  setUpUser(data) {
    return Instance.post('/AQun/QunMemberManager/SetUpUser', qs.stringify(data));
  },
  // 获取群申请信息
  getApplyInfo(data) {
    return Instance.post('/AQun/QunMemberManager/GetApplyInfo', qs.stringify(data));
  },
  // 获取-创建群将默认转入房卡数量
  getAddQunAutoNum(data) {
    return Instance.post('/AQun/QunManager/GetAddQunAutoNum', qs.stringify(data));
  },
  // 获取-获取群设置信息
  getQunSetting(data) {
    return Instance.post('/AQun/QunManager/GetQunSetting', qs.stringify(data));
  },
  //设置每位成员每日耗卡上限
  setQunMemberMaxConsume(data) {
    return Instance.post('/AQun/QunManager/QunMemberMaxConsume', qs.stringify(data));
  },
  //群房卡提醒
  setQunFangKaTip(data) {
    return Instance.post('/AQun/QunManager/QunFangKaTip', qs.stringify(data));
  },
  //自动转入
  setQunFangKaAutoRollIn(data) {
    return Instance.post('/AQun/QunManager/QunFangKaAutoRollIn', qs.stringify(data));
  },
  //群打烊-开启
  startShutdown(data) {
    return Instance.post('/AQun/QunManager/Shutdown', qs.stringify(data));
  },
  //群打烊-关闭
  endShutdown(data) {
    return Instance.post('/AQun/QunManager/EndShutdown', qs.stringify(data));
  },
  //设置微信
  setWeiXin(data) {
    return Instance.post('/AQun/QunManager/SetWeiXin', qs.stringify(data));
  },
  //不用手机号的验证码
  getSendAgentCode(data) {
    return Instance.post('/MsgHandle/SendAgentCode', qs.stringify(data));
  },
  //转入房卡
  setRollIn(data) {
    return Instance.post('/AQun/QunFangKa/RollIn', qs.stringify(data));
  },
  //获取全部战绩
  getDetail(data) {
    return Instance.post('/AQun/QunZhanJi/GetDetail', qs.stringify(data));
  },
  //群房卡转入数量汇总
  getSum(data) {
    return Instance.post('/AQun/QunFangKa/Sum', qs.stringify(data));
  },
  //战绩统计
  getWinLoseCount(data) {
    return Instance.post('/AQun/QunZhanJi/GetWinLoseCount', qs.stringify(data));
  },
  //大赢家统计
  getBigWiner(data) {
    return Instance.post('/AQun/QunZhanJi/GetBigWiner', qs.stringify(data));
  },
  //耗卡数
  getFankaConsume(data) {
    return Instance.post('/AQun/QunZhanJi/GetFankaConsume', qs.stringify(data));
  },
  //获取账户数据
  getAccountQunFangKa(data) {
    return Instance.post('/AQun/QunFangKa/Get', qs.stringify(data));
  },
  //获取群比例
  getQunBiLi(data) {
    return Instance.post('/AQun/QunReward/GetQunBiLi', qs.stringify(data));
  },
  //微信登录
  getOpenidAndAccessToken(data) {
    return Instance.post('/Home/GetOpenidAndAccessToken', qs.stringify(data));
  },
  //获取充值信息
  getPayInfo(data) {
    return Instance.post('/AQun/PayQunFangKa/GetPayInfo', qs.stringify(data));
  },
  //调起充值
  getJsApiParam(data) {
    return Instance.post('/AQun/PayQunFangKa/GetJsApiParam', qs.stringify(data));
  },
  //获取我的奖励
  getQunReward(data) {
    return Instance.post('/AQun/QunReward/Sum', qs.stringify(data));
  },
  //获取奖励详情
  getQunHongLiSouce(data) {
    return Instance.post('/AQun/QunReward/GetQunHongLiSouce', qs.stringify(data));
  },
  //兑换奖励
  postHongLiToGold(data) {
    return Instance.post('/AQun/QunReward/HongLiToGold', qs.stringify(data));
  },
  //兑换奖励记录
  getHongLiToGoldLog(data) {
    return Instance.post('/AQun/QunReward/GetHongLiToGoldLog', qs.stringify(data));
  },
  //修改群比例
  setQunBiLi(data) {
    return Instance.post('/AQun/QunReward/SetQunBiLi', qs.stringify(data));
  },
  //群房卡充值-创建支付宝订单
  postCreatePayOrderWeb(data) {
    return Instance.post('/AQun/PayQunFangKa/CreatePayOrderWeb', qs.stringify(data));
  },
  //验证群权限
  getVerifyPermissions(data) {
    return Instance.post('/Home/IsQunManager', qs.stringify(data));
  },
  //群房卡-房卡转账明细
  getGetTransdetail(data) {
    return Instance.post('/AQun/QunFangKa/GetTrans', qs.stringify(data));
  },
  //群房卡-房卡转账
  trunGetTransdetail(data) {
    return Instance.post('/AQun/QunFangKa/Trans', qs.stringify(data));
  },
  //账号相关接口-获取会长信息
  getAgent(data) {
    return Instance.post('/Account/GetAgent', qs.stringify(data));
  },
  //群房卡-房卡转账汇总
  getReport(data) {
    return Instance.post('/AQun/QunFangKa/GetReport', qs.stringify(data));
  },
  //群房卡-房卡转账汇总-给每个玩家
  getReportEachUser(data) {
    return Instance.post('/AQun/QunFangKa/GetReportEachUser', qs.stringify(data));
  },
  //个人群房卡日志-获取房卡数据
  getAgentFangKaLog(data) {
    return Instance.post('/AQun/AgentFangKaLog/Get', qs.stringify(data));
  },
  //群成员管理-获取群分组信息
  getGroupList(data) {
    return Instance.post('/AQun/QunMemberManager/GetGroup', qs.stringify(data));
  },
  //对局统计-对局统计
  getQunZhanJiCount(data) {
    return Instance.post('/AQun/QunZhanJiCount/GetWinLoseCount', qs.stringify(data));
  },
  //模式开关
  patternSwitch(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/Switch', qs.stringify(data));
  },
  //娱乐场管理
  getUserCurrencyNum(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/GetUserCurrencyNum', qs.stringify(data));
  },
  //群娱乐场-娱乐场游戏记录
  getUserManagerLog(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/GetUserManagerLog', qs.stringify(data));
  },
  //群娱乐场-场控记录
  getGameRecord(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/GetGameRecord', qs.stringify(data));
  },
  //群娱乐场-战斗值统计
  getCurrencyGroup(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/CurrencyGroup', qs.stringify(data));
  },
  //群娱乐场-剩余战斗值
  getUserCurrencySum(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/GetUserCurrencySum', qs.stringify(data));
  },
  //群娱乐场-设置
  setRecreationConfig(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/SetConfig', qs.stringify(data));
  },
  //群娱乐场-获取当前设置
  getRecreationConfig(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/GetConfig', qs.stringify(data));
  },
  //群娱乐场-设置玩家的娱乐值
  setUser(data) {
    return Instance.post('/AQun/QunEntertainmentScreen/SetUser', qs.stringify(data));
  },
  //娱乐场-获取群分组
  getGroupdistinction(data) {
    return Instance.get('/AQun/QunEntertainmentScreenCommon/GetGroup' + '?' + qs.stringify(data));
  },
  //娱乐场-对局统计
  getChessList(data) {
    return Instance.get('/AQun/QunEntertainmentScreenCommon/GetQunZhanJiYLStatistics' + '?' + qs.stringify(data));
  },
  //领卡
  receiveAward(data) {
    return Instance.post('/AQun/QunFangKa/AddFreeQunFangka', qs.stringify(data));
  },
}



// WEBPACK FOOTER //
// ./src/api/product.js